import { z } from "zod";

/**
 * Shape of the JSON body returned by `PUT /api/deployments/:id` (and CREATE)
 * when a WhatsApp sender is already attached to a different active WhatsApp
 * deployment and the request did not set `force: true`. The frontend parses
 * this with `safeParse` instead of an inline cast so the type narrows safely
 * even if the backend payload drifts.
 */
export const WhatsappSenderInUseErrorSchema = z.object({
  error: z.literal("WHATSAPP_SENDER_IN_USE"),
  message: z.string(),
  previousDeploymentId: z.string().uuid(),
  previousDeploymentName: z.string()
});

export type WhatsappSenderInUseErrorBody = z.infer<typeof WhatsappSenderInUseErrorSchema>;
